import React from "react";
import { Link } from "react-router-dom";
import MaterialIcon from "../../../shared/components/MaterialIcon";
import { useTranslation } from "../../../i18n";

const ARTICLE_ICONS = {
  impersonation: "login",
  "case-outcomes": "gavel",
  "user-roles": "admin_panel_settings",
  "review-moderation": "rate_review",
  "deletion-workflow": "assignment",
};

const ARTICLE_KEYS = {
  impersonation: {
    title: "adminDocs.impersonationTitle",
    description: "adminDocs.impersonationDesc",
  },
  "case-outcomes": {
    title: "adminDocs.caseOutcomesTitle",
    description: "adminDocs.caseOutcomesDesc",
  },
  "user-roles": {
    title: "adminDocs.userRolesTitle",
    description: "adminDocs.userRolesDesc",
  },
  "review-moderation": {
    title: "adminDocs.reviewModerationTitle",
    description: "adminDocs.reviewModerationDesc",
  },
  "deletion-workflow": {
    title: "adminDocs.deletionWorkflowTitle",
    description: "adminDocs.deletionWorkflowDesc",
  },
};

const ARTICLE_IDS = Object.keys(ARTICLE_KEYS);

const AdminDocumentationPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-background font-body-md text-on-surface">
      <div className="mx-auto max-w-container-max px-margin-mobile py-stack-lg md:px-margin-desktop">
        <nav className="mb-stack-lg">
          <Link
            to="/dashboard/admin"
            className="group inline-flex items-center gap-2 transition-colors"
          >
            <MaterialIcon
              name="arrow_back"
              className="text-[20px] text-outline transition-colors group-hover:text-primary"
            />
            <span className="font-label-sm text-outline transition-colors group-hover:text-primary">
              {t("common.backToDashboard")}
            </span>
          </Link>
        </nav>

        <h1 className="font-headline-lg text-headline-lg text-primary">
          {t("adminDocs.title")}
        </h1>
        <p className="mt-2 max-w-2xl text-body-md text-on-surface-variant">
          {t("adminDocs.subtitle")}
        </p>

        <div className="architect-gradient mt-stack-lg rounded-2xl p-stack-lg">
          <p className="font-label-caps text-inverse-primary/70">{t("adminDocs.featured")}</p>
          <h2 className="mt-2 font-headline-md text-inverse-on-surface">
            {t("adminDocs.impersonationTitle")}
          </h2>
          <p className="mt-2 max-w-xl text-[13px] leading-relaxed text-inverse-primary/80">
            {t("adminDocs.impersonationDesc")}
          </p>
          <Link
            to="/dashboard/admin/users"
            className="mt-4 inline-flex items-center gap-2 rounded-lg bg-secondary px-4 py-2 text-label-sm font-medium text-on-primary"
          >
            {t("adminDocs.openUsers")}
            <MaterialIcon name="arrow_forward" />
          </Link>
        </div>

        <div className="mt-stack-lg grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {ARTICLE_IDS.map((id) => (
            <article
              key={id}
              className="tonal-card rounded-xl border border-outline-variant/30 p-stack-lg"
            >
              <MaterialIcon
                name={ARTICLE_ICONS[id]}
                className="mb-3 text-2xl text-secondary"
              />
              <h3 className="font-headline-md text-[16px] text-primary">
                {t(ARTICLE_KEYS[id].title)}
              </h3>
              <p className="mt-2 text-[12px] leading-relaxed text-on-surface-variant">
                {t(ARTICLE_KEYS[id].description)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDocumentationPage;
